import { Card, Col, Row, Typography } from 'antd'
import { Link } from 'react-router-dom'

const { Title, Paragraph } = Typography

const LegalNoticesPage = () => {
  return (
    <Card>
      <Row>
        <Col span={24}>
          <Title level={3}>MENTIONS LÉGALES</Title>
          <Paragraph>
            Le présent site internet est édité et exploité par SUPPLEMENT BACON,
            société par actions simplifiée unipersonnelle au capital de 500,00
            euros, immatriculée au Registre du Commerce et des Sociétés de Paris
            sous le numéro 892&nbsp;691&nbsp;650, dont le siège social est situé
            au 7 rue Narcisse Diaz, 75016 PARIS ayant pour numéro de TVA
            intracommunautaire FR22892691650.
          </Paragraph>
          <Paragraph>
            Vous pouvez nous joindre par courrier électronique à
            l&apos;adresse&nbsp;
            <Link to="mailto:support@echow.app">support@echow.app</Link>.
          </Paragraph>
          <Paragraph>
            Le directeur de publication est Madame Carole MEGNA.
          </Paragraph>
          <Paragraph>
            Ce site est hébergé par la société{' '}
            <Link to="https://vercel.com/legal/terms">Vercel Inc</Link>.
          </Paragraph>
        </Col>
      </Row>
    </Card>
  )
}

export default LegalNoticesPage
